export enum DeviceScreenSizes {
  Mobile = 320,
  MobileMid = 544,
  MobileMax = 767,
  Tablet = 768,
  TabletMax = 1024,
  Desktop = 1025,
  Widescreen = 1440,
}
